import { IConfiguration, Platform, Tenant } from './IConfiguration';

export default class CellnexConfiguration implements IConfiguration {
    // domains of environments (hardcoded - react doesn't allow changes on runtime)
    readonly irisTestDomain = 'iris.modelical.io';
    readonly irisCellnexDevDomain = 'link-dev-iris.cellnextelecom.com';
    readonly irisCellnexPreDomain = 'link-pre-iris.cellnextelecom.com';
    readonly irisCellnexProDomain = 'link-iris.cellnextelecom.com';

    // configuration attributes
    auth: any | undefined;
    parentUrl: string | undefined;
    adminMicroserviceUrl: string;
    proxyMicroserviceUrl: string;
    syncMicroserviceUrl: string;
    mioAdminUrl: string;
    parentDomain: string;
    cookiesSubfix: string;
    procoreUrl: string;
    aconexUrl: string;

    constructor() {
        // set up configuration attributes based on environment
        if (window.location.hostname.endsWith(this.irisCellnexDevDomain)) {
            this.auth = {
                auth: {
                    clientId: '3aedca30-d8a5-4bcd-ba80-f5e1aeaf9f5f',
                    authority: 'https://login.microsoftonline.com/05088b6e-1d96-4f6b-8918-48957eca4f00',
                    redirectUri: `https://${this.irisCellnexDevDomain}`,
                    postLogoutRedirectUri: `https://${this.irisCellnexDevDomain}`,
                    navigateToLoginRequestUrl: true,
                    OIDCOptions: {
                        defaultScopes: ['3aedca30-d8a5-4bcd-ba80-f5e1aeaf9f5f/.default'],
                    },
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: false,
                },
            };

            this.parentUrl = `https://iris-dev.cellnextelecom.com`;
            this.adminMicroserviceUrl = `https://link-admin-dev-iris.cellnextelecom.com`;
            this.proxyMicroserviceUrl = `https://link-proxy-dev-iris.cellnextelecom.com`;
            this.syncMicroserviceUrl = `https://link-sync-dev-iris.cellnextelecom.com`;
            this.mioAdminUrl = `https://admin-api-dev-iris.cellnextelecom.com`;
            this.parentDomain = 'cellnextelecom.com';
            this.cookiesSubfix = 'DevIrisCellnex';
            this.procoreUrl = 'https://login-sandbox.procore.com';
            this.aconexUrl = 'https://constructionandengineering.oraclecloud.com';
        } else if (window.location.hostname.endsWith(this.irisCellnexPreDomain)) {
            this.auth = {
                auth: {
                    clientId: '4a50de9a-83e2-480b-ad8d-205c49a5f3ef',
                    authority: 'https://login.microsoftonline.com/05088b6e-1d96-4f6b-8918-48957eca4f00',
                    redirectUri: `https://${this.irisCellnexPreDomain}`,
                    postLogoutRedirectUri: `https://${this.irisCellnexPreDomain}`,
                    navigateToLoginRequestUrl: true,
                    OIDCOptions: {
                        defaultScopes: ['4a50de9a-83e2-480b-ad8d-205c49a5f3ef/.default'],
                    },
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: false,
                },
            };

            this.parentUrl = `https://iris-pre.cellnextelecom.com`;
            this.adminMicroserviceUrl = `https://link-admin-pre-iris.cellnextelecom.com`;
            this.proxyMicroserviceUrl = `https://link-proxy-pre-iris.cellnextelecom.com`;
            this.syncMicroserviceUrl = `https://link-sync-pre-iris.cellnextelecom.com`;
            this.mioAdminUrl = `https://admin-api-pre-iris.cellnextelecom.com`;
            this.parentDomain = 'cellnextelecom.com';
            this.cookiesSubfix = 'PreIrisCellnex';
            this.procoreUrl = 'https://login-sandbox.procore.com';
            this.aconexUrl = 'https://constructionandengineering.oraclecloud.com';
        } else if (window.location.hostname.endsWith(this.irisCellnexProDomain)) {
            this.auth = {
                auth: {
                    clientId: '96c4472e-31c9-4e81-a58e-52c2e49cb33a',
                    authority: 'https://login.microsoftonline.com/05088b6e-1d96-4f6b-8918-48957eca4f00',
                    redirectUri: `https://${this.irisCellnexProDomain}`,
                    postLogoutRedirectUri: `https://${this.irisCellnexProDomain}`,
                    navigateToLoginRequestUrl: true,
                    OIDCOptions: {
                        defaultScopes: ['96c4472e-31c9-4e81-a58e-52c2e49cb33a/.default'],
                    },
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: false,
                },
            };

            this.parentUrl = `https://iris.cellnextelecom.com`;
            this.adminMicroserviceUrl = `https://link-admin-iris.cellnextelecom.com`;
            this.proxyMicroserviceUrl = `https://link-proxy-iris.cellnextelecom.com`;
            this.syncMicroserviceUrl = `https://link-sync-iris.cellnextelecom.com`;
            this.mioAdminUrl = `https://admin-api-iris.cellnextelecom.com`;
            this.parentDomain = 'cellnextelecom.com';
            this.cookiesSubfix = 'IrisCellnex';
            this.procoreUrl = 'https://login.procore.com';
            this.aconexUrl = 'https://constructionandengineering.oraclecloud.com';
        } else {
            this.auth = {
                auth: {
                    clientId: 'cbe2d945-b4ec-4ccf-a6fb-d93fc1263602',
                    authority: 'https://login.microsoftonline.com/d8c21a0f-8e79-48d2-9314-075f557b317d',
                    redirectUri: `https://link.${this.irisTestDomain}`,
                    postLogoutRedirectUri: `https://link.${this.irisTestDomain}`,
                    navigateToLoginRequestUrl: true,
                    OIDCOptions: {
                        defaultScopes: ['cbe2d945-b4ec-4ccf-a6fb-d93fc1263602/.default'],
                    },
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: false,
                },
            };

            this.parentUrl = `https://iris.modelical.io`;
            this.adminMicroserviceUrl = `https://admin.link.${this.irisTestDomain}`;
            this.proxyMicroserviceUrl = `https://proxy.link.${this.irisTestDomain}`;
            this.syncMicroserviceUrl = `https://sync.link.${this.irisTestDomain}`;
            this.mioAdminUrl = `https://admin.api.${this.irisTestDomain}`;
            this.parentDomain = 'iris.modelical.io';
            this.cookiesSubfix = 'IrisModelicalIo';
            this.procoreUrl = 'https://login-sandbox.procore.com';
            this.aconexUrl = 'https://constructionandengineering.oraclecloud.com';
        }
    }

    getPlatform = (): Platform => {
        return 'azure';
    };

    getAuth = (): any | undefined => {
        return this.auth;
    };

    getParentUrl = (): string | undefined => {
        return this.parentUrl;
    };

    getAdminMicroserviceUrl = (): string => {
        return this.adminMicroserviceUrl;
    };

    getProxyMicroserviceUrl = (): string => {
        return this.proxyMicroserviceUrl;
    };

    getSyncMicroserviceUrl = (): string => {
        return this.syncMicroserviceUrl;
    };

    getMioAdminUrl = (): string => {
        return this.mioAdminUrl;
    };

    getTenant = (): Tenant => {
        return 'cellnex';
    };

    getParentDomain = (): string => {
        return this.parentDomain;
    };

    getCookiesSubfix = (): string => {
        return this.cookiesSubfix;
    };

    getProcoreUrl = (): string => {
        return this.procoreUrl;
    };

    getAconexUrl = (): string => {
        return this.aconexUrl;
    };
}
